export const HACCP_BASE_URL = '/haccp';

/** 食品メーカー向けサービス それぞれの画面のパス定数 */
const HaccpPathConstants = {
    Home                                        : HACCP_BASE_URL,
    TempMeasurementRegistration                 : `${HACCP_BASE_URL}/registration/temp-measurement`,
    CookingTempMeasurementRegistration          : `${HACCP_BASE_URL}/registration/cooking-temp-measurement`,
    HeatingAndCoolingTempMeasurementRegistration: `${HACCP_BASE_URL}/registration/heating-cooling-temp-measurement`,
    TempMeasurementRecord                       : `${HACCP_BASE_URL}/record/temp-measurement`,
    ReceivingTempMeasurementRecord              : `${HACCP_BASE_URL}/record/receiving-temp-measurement`,
    CookingTempMeasurementRecord                : `${HACCP_BASE_URL}/record/cooking-temp-measurement`,
    HeatingAndCoolingTempMeasurementRecord      : `${HACCP_BASE_URL}/record/heating-cooling-temp-measurement`,
    CabinetTempMeasurementRecord                : `${HACCP_BASE_URL}/record/cabinet-temp-measurement`,
};

export default HaccpPathConstants;
